<template>
    <div class="place-unavailable">
        <div class="place-unavailable-card">
            <img src="/images/logo-kevi-white.svg" alt="Kevi" class="place-unavailable-logo" @error="hideImage" />

            <h1 v-lang="titleTerm"></h1>
            <p v-lang="descriptionTerm"></p>

            <button v-if="variant === 'error'" type="button" class="place-unavailable-retry" @click="retry">
                {{ t("common-error-retry") }}
            </button>
        </div>
    </div>
</template>

<script>
export default {
    name: "PlaceUnavailable",
    props: {
        variant: {
            type: String,
            default: "not-found",
        },
    },
    computed: {
        titleTerm() {
            return this.variant === "error" ? "common-error-title" : "common-notFound-title";
        },
        descriptionTerm() {
            return this.variant === "error" ? "common-error-description" : "common-notFound-description";
        },
    },
    methods: {
        t(term, replaces) {
            return this.$root.t(term, replaces);
        },
        hideImage(event) {
            event.target.style.display = "none";
        },
        retry() {
            window.location.reload();
        },
    },
};
</script>

<style lang="scss" scoped>
.place-unavailable {
    align-items: center;
    background: #0d121c;
    display: flex;
    justify-content: center;
    min-height: 100vh;
    padding: 24px;
    width: 100%;
}

.place-unavailable-card {
    color: #ffffff;
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 12px;
    max-width: 22rem;
    text-align: center;

    h1 {
        font-size: 1.25rem;
        font-weight: 600;
        line-height: 1.3;
        margin: 12px 0 0;
    }

    p {
        color: #b8bfcc;
        font-size: 0.875rem;
        line-height: 1.5;
        margin: 0;
    }
}

.place-unavailable-logo {
    height: 1.75rem;
}

.place-unavailable-retry {
    background: transparent;
    border: 1px solid #ffffff;
    border-radius: 6px;
    color: #ffffff;
    cursor: pointer;
    font-size: 0.875rem;
    margin-top: 8px;
    padding: 10px 20px;

    &:hover {
        background: rgba(255, 255, 255, 0.1);
    }
}
</style>
